import React, { useState } from "react";
import "./theashes.css";

const tabs = [
  "ALL",
  "Fancy",
  "Line Markets",
  "Ball by Ball",
  "Meter Markets",
  "Khado Markets",
];

const TheAshesData = [
  {
    name: "Total 1st Over Runs Of Ashes(1st Inn)",
    no: 13,
    yes: 15,
    minmax: "100 - 25000",
  },
  {
    name: "Total 1st 5 Over Runs of Ashes(1st Inn)",
    no: 87,
    yes: 92,
    minmax: "100 - 25000",
  },
  {
    name: "Total 1st 10 Over Runs of Ashes(1st Inn)",
    no: 170,
    yes: 180,
    minmax: "100 - 25000",
  },
  {
    name: "Highest Single Innings Score of Ashes",
    no: 500,
    yes: 530,
    minmax: "100 - 25000",
  },
  {
    name: "Highest Total Runs of Ashes",
    no: "1,275",
    yes: "1,325",
    minmax: "100 - 25000",
  },
];

const TheAshes = () => {
  const [activeTab, setActiveTab] = useState("ALL");

  return (
    <div className="container-fluid px-0 ashes-container">
      {/* Top Switch Header */}
      <div className="ashesswitch-header">
        <button className="active">Fancy Bet</button>
        <button>Sportsbook</button>
        <i className="info-icon">ℹ️</i>
      </div>

      {/* Category Tabs */}
      <div className="ashestabs-container d-flex overflow-auto align-items-right px-2">
        {tabs.map((t, i) => (
          <button
            key={i}
            className={`tab-btn ${activeTab === t ? "active" : ""}`}
            onClick={() => setActiveTab(t)}
          >
            {t}
          </button>
        ))}
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered ashes-table">
          <thead>
            <tr>
              <th>Market</th>
              <th>Book</th>
              <th className="no-col bg-secondary" >
                No
              </th>
              <th className="yes-col bg-primary">Yes</th>
              <th className="bg-success">Min/Max</th>
            </tr>
          </thead>

          <tbody>
            {TheAshesData.map((row, index) => (
              <tr key={index}>
                <td className="market-name">{row.name}</td>
                <td>
                  <button className="book-btn">Book</button>
                </td>
                <td className="no-col odds-cell bg-secondary">
                  <strong>{row.no}</strong>
                  <div className="small text-dark ">100</div>
                </td>
                <td className="yes-col odds-cell bg-primary">
                  <strong>{row.yes}</strong>
                  <div className="small text-dark">110</div>
                </td>
                <td className="bg-success">{row.minmax}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TheAshes;
